import * as React from 'react';

import {ChevronDownIcon} from '../../icon';
import {Body} from '../../typography/body';

import {getRecipientFromSelectedTextable} from '../helpers';
import {RecipientDisplay} from '../thread-header/recipient-display';
import type {Textable} from '../types';

import styles from './textable-select.module.css';

type Props = {
    getRef: any;
    onClick: () => void;
    selectedTextable: Textable | null | undefined;
};

export function SelectedButton(props: Props) {
    return (
        <button ref={props.getRef} onClick={props.onClick} className={styles.container}>
            {props.selectedTextable ? (
                <RecipientDisplay
                    recipient={getRecipientFromSelectedTextable(props.selectedTextable)}
                    isLinkable={false}
                />
            ) : (
                <div className='mr-8'>
                    <Body size='normal'>Select a recipient…</Body>
                </div>
            )}
            <ChevronDownIcon size={12} />
        </button>
    );
}
